import { FREE_PLAN_HANDLE, FREE_TRIAL_DAYS } from 'constants/billing';
import { useUpgradePlan } from 'hooks/billing/useUpgradePlan';
import { useTranslation } from 'react-i18next';
import { transformToCdnUrl } from 'utils/google-storage-util';
import { WelcomeCardPlanFeatures } from '../../welcome-card/components/WelcomeCardPlanFeatures';
import { WelcomeCard } from '../../welcome-card/WelcomeCard';

// Welcome card for shops without a subscription yet
export const DashboardWelcomeCard: React.FC = () => {
    const { t } = useTranslation();
    const { name: upgradePlanName, handle: upgradePlanHandle, trialDays } = useUpgradePlan();

    return (
        <WelcomeCard
            eyebrow={t('DASHBOARD.WELCOME_CARD.EYEBROW')}
            title={t('DASHBOARD.WELCOME_CARD.TITLE')}
            description={t('DASHBOARD.WELCOME_CARD.DESCRIPTION', { count: trialDays, plan: upgradePlanName })}
            image={{
                src: transformToCdnUrl('embedded-assets/tiles/integration-design-tile.webp'),
                alt: 'integration-design',
            }}
        >
            <WelcomeCardPlanFeatures
                plans={[
                    { handle: FREE_PLAN_HANDLE, label: 'Free', icon: 'rocket' },
                    { handle: upgradePlanHandle, label: upgradePlanName, icon: 'bolt' },
                ]}
            />
        </WelcomeCard>
    );
};
